import history from 'shared/util/routing/history'

export function goToDeal(id: string, skipDirtyPrompt?: boolean, state?: Record<string, any>) {
  if (skipDirtyPrompt) {
    return history.replace(`/deals/edit/${encodeURIComponent(id)}`, {
      skipDirtyPrompt: true,
      ...state
    })
  }
  return history.push(`/deals/edit/${encodeURIComponent(id)}`, state)
}
